package fr.frux.core.billing.di

import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.Provides
import dev.zacsweers.metro.SingleIn
import fr.frux.core.billing.DefaultStorePurchases
import fr.frux.core.billing.StorePurchases
import fr.frux.core.billing.createBillingPlatform
import fr.frux.core.common.di.AppScope
import fr.frux.core.common.entitlements.EntitlementsHolder
import fr.frux.core.common.entitlements.EntitlementsRefresher
import fr.frux.core.network.api.PremiumApi
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob

/**
 * Module Metro de l'achat en store (#457), sur le modèle d'`AdsModule`. Portée de l'application :
 * le rattrapage des achats non acquittés suit les changements de compte pendant toute la vie de l'app.
 */
@ContributesTo(AppScope::class)
interface BillingModule {
    companion object {
        @Provides
        @SingleIn(AppScope::class)
        fun provideStorePurchases(
            premiumApi: PremiumApi,
            entitlements: EntitlementsHolder,
            refresher: EntitlementsRefresher,
        ): StorePurchases =
            DefaultStorePurchases(
                platform = createBillingPlatform(),
                premiumApi = premiumApi,
                entitlements = entitlements,
                refresher = refresher,
                scope = CoroutineScope(SupervisorJob() + Dispatchers.Main),
            )
    }
}
